/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { oktaServerSuggestionsList } from "../funcs/oktaServerSuggestionsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListOktaServerSuggestionsResult } from "../models/components/listoktaserversuggestionsresult.js";
import {
  ListOktaServerSuggestionsRequest,
  ListOktaServerSuggestionsSecurity,
} from "../models/operations/listoktaserversuggestions.js";
import { unwrapAsync } from "../types/fp.js";
export type OktaServerSuggestionsQueryData = ListOktaServerSuggestionsResult;

export function prefetchOktaServerSuggestions(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListOktaServerSuggestionsRequest | undefined,
  security?: ListOktaServerSuggestionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOktaServerSuggestionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildOktaServerSuggestionsQuery(
  client$: GramCore,
  request?: ListOktaServerSuggestionsRequest | undefined,
  security?: ListOktaServerSuggestionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OktaServerSuggestionsQueryData>;
} {
  return {
    queryKey: queryKeyOktaServerSuggestions({
      includeAll: request?.includeAll,
      gramSession: request?.gramSession,
    }),
    queryFn: async function oktaServerSuggestionsQueryFn(
      ctx,
    ): Promise<OktaServerSuggestionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(oktaServerSuggestionsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyOktaServerSuggestions(
  parameters: {
    includeAll?: boolean | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "oktaServerSuggestions", "list", parameters];
}
